import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bwc-control-bar',
  templateUrl: './control-bar.component.html',
  styleUrls: ['./control-bar.component.scss'],
})
export class ControlBarComponent {
  @Input() prevBut: boolean;
  @Input() closeBut: boolean;
  @Input() progresBar = false;

  @Output() emitClose = new EventEmitter();
  @Output() emitPrev = new EventEmitter();

  close() {
    this.emitClose.emit();
  }

  prev() {
    this.emitPrev.emit();
  }
}
